const reloadHandler = (event) => {
  event.preventDefault();
  event.returnValue = "";
};

export const preventReload = () => {
  // Safety
  window.removeEventListener("beforeunload", reloadHandler);

  window.addEventListener("beforeunload", reloadHandler);
};

export const allowReload = () => {
  window.removeEventListener("beforeunload", reloadHandler);

  setTimeout(() => {
    preventReload();
  }, 500);
};

export const redirect = (url) => {
  window.removeEventListener("beforeunload", reloadHandler);

  window.location.href = url;
};
